import styles from './Use.module.css';

function Use(){
    return (
        <section id="como-usar" className={`${styles.use}`}>
            <h2 className="text-white">Como Usar?</h2>
            <div className="d-flex justify-content-center gap-3 flex-wrap mt-5">
                <div className={`${styles.use_card} card`}>
                    <div className={`${styles.header} container-fluid bg-primary text-white d-flex align-items-center justify-content-center display-1`}>1</div>
                    <div className="card-body">
                        <h3 className="card-title fs-6">Crie uma nova atividade</h3>
                        <p className="card-text fs-6">Crie uma nova atividade pressionando o botão <b><i>ADD. ATIVIDADE</i></b>, na parte inferior direita da tela.</p>
                    </div>
                </div>
                <div className={`${styles.use_card} card`}>
                    <div className={`${styles.header} container-fluid bg-primary text-white d-flex align-items-center justify-content-center display-1`}>2</div>
                    <div className="card-body">
                        <h3 className="card-title fs-6">Inicie a atividade</h3>
                        <p className="card-text fs-6">Selecione a atividade criada e clique no botão <b><i>Iniciar</i></b>, na região inferior direita da tela. Essa ação marca  o início da realização da atividade no dia.</p>
                    </div>
                </div>
                <div className={`${styles.use_card} card`}>
                    <div className={`${styles.header} container-fluid bg-primary text-white d-flex align-items-center justify-content-center display-1`}>3</div>
                    <div className="card-body">
                        <h3 className="card-title fs-6">Finalize a atividade</h3>
                        <p className="card-text fs-6">Após finalizar a atividade, clique no botão <b><i>Parar</i></b>, na região inferior direita da tela. Essa ação marca o término da atividade no dia. Após essa ação será calculado o tempo que você se dedicou a atividade.</p>
                    </div>
                </div>
            </div>
            <div className={`${styles.info} d-lg-flex bg-white mt-5 mx-auto px-4`}>
                <div className="fw-bold my-auto">!</div>
                <p className="text-primary fw-bold fs-6 my-auto">Você pode iniciar e finalizar uma determinada atividade quantas vezes quiser no mesmo dia, registrando vários horários de início, término e tempos de duração. Por meio de todos os tempos de duração registrados em uma data é calculado a dedicação total à atividade no dia.</p>
            </div>
        </section>
    )
}

export default Use;